<template>
  <div class="examine-table my-4 mb-10">
    <div class="py-2 px-3 flex justify-between">
      <span class="font-semibold text-medium-x leading-22 text-theme-black-850">{{ title }}</span>
      <div class="btn-group">
        <el-button :disabled="disabledAddUserBtn" type="primary" size="small" @click="onClickAdd">添加审核员</el-button>
        <span class="ml-3">
          <el-button size="small" @click="onClickDel">删除层级</el-button>
        </span>
      </div>
    </div>
    <div class="table-content">
      <el-table
        size="mini"
        :height="216"
        empty-text="无审核员"
        :data="tableData"
        header-row-class-name="table-header-row"
        :cell-style="{ borderColor: '#D9DDE0' }"
        :header-cell-style="{ borderColor: '#D9DDE0' }"
      >
        <el-table-column label="序号" type="index" :width="80"></el-table-column>
        <el-table-column prop="name" label="审核员姓名" :width="240"></el-table-column>
        <el-table-column prop="mobile" label="手机号" :width="240"></el-table-column>
        <el-table-column prop="" label="可修改答卷" :width="100">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.allowModifyAnswers"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="" label="状态" align="right">
          <template slot-scope="scope">
            <span>{{ companyStatus[scope.row.status].text }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="right">
          <template slot-scope="scope">
            <span class="text-theme cursor-pointer" @click="onClickDelUser(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { num2Text } from '@/assets/js/utils.js'
import { companyStatus } from '@/global/config-variable.js'

export default {
  name: 'ExamineTable',
  props: {
    disabledAddUserBtn: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: -1
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: ''
    }
  },
  watch: {
    zIndex: {
      handler() {
        this.title = num2Text(this.zIndex) + '级审核'
      },
      immediate: true
    }
  },
  created() {
    this.companyStatus = companyStatus
  },
  methods: {
    onClickDelUser(item) {
      this.$emit('del-user', item)
    },
    onClickDel() {
      this.$emit('del-audit')
    },
    onClickAdd() {
      this.$emit('add-user')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table {
  @apply bg-transparent;
}
::v-deep .table-header-row {
  @apply bg-transparent;
  .el-table__cell {
    @apply bg-transparent;
    .cell {
      @apply text-medium font-normal text-theme-text-gray opacity-65;
    }
  }
}
::v-deep .el-table__row {
  @apply bg-transparent;
  .el-table__cell {
    @apply bg-transparent;
    .cell {
      @apply text-medium font-normal text-theme-black-650;
    }
  }
}
</style>
